// IMAGE SEQUENCE


$(document).ready(function () {
    var pictureCount = $('.section-image-seqence #container img').length;
    var firstbox = $(".banner__content").height();
    var scrollResolution = 500;
    var scrollResolutionMobile = 50;

    //animateHorse();
    
    function animateHorse() {
      var windowSize = $(window).width();
      if (windowSize <= 479) {
        var currentScrollPosition = window.pageYOffset - firstbox;
        var imageIndex = Math.round(currentScrollPosition / scrollResolutionMobile);
        
        if (imageIndex >= pictureCount) {
            imageIndex = pictureCount - 1; // Select last image
        }
        
        $("#container img").hide();
        $("#container img").eq(imageIndex).show();
      }
      else {
        var currentScrollPosition = window.pageYOffset - firstbox;
        var imageIndex = Math.round(currentScrollPosition / scrollResolution);
        
        if (imageIndex >= pictureCount) {
            imageIndex = pictureCount - 1; // Select last image
        }
        
        $("#container img").hide();
        $("#container img").eq(imageIndex).show();
      }
    }
    $(window).resize(animateHorse);
    $(window).bind('scroll', function() {
    if (this.scrollY > firstbox) {
      animateHorse();
    }
  });
});
	
/* ABZ Vertical Slider MOBILE */
$('.hr_slider').slick({
  slidesToScroll: 1,
  dots: false,
  autoplay: true,
  autoplaySpeed: 3000,
  vertical: false,
  verticalSwiping: false,
  infinite: true,
  arrows: true
});
/* End Vertical Slider */


jQuery(function($) {
  var path = window.location.href; 
  // because the 'href' property of the DOM element is the absolute path
  $('li').each(function() {
    if (this.href === path) {
      $(this).addClass('active');
    }
  });
});



// ADD ID 

$(".icon-with-text--vertical").each(function () {
    $(this).uniqueId();
});


$(".product__accordion").each(function () {
    $(this).uniqueId();
});

/* Collection */
$('.collection-slider-HP').slick({
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: true,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToScroll: 1,
        slidesToShow: 3
      }
    },
    {
      breakpoint: 990,
      settings: {
        slidesToScroll: 1,
        slidesToShow: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToScroll: 1,
        slidesToShow: 2
      }
    },
  ]
});

/* Product Selection */
$('.abz_product-section').slick({
  infinite: true,
  slidesToShow: 4,
  slidesToScroll: 1, 
  responsive: [  
    {
      breakpoint: 990,
      settings: {
        slidesToScroll: 1,
        slidesToShow: 2,
        arrows: false,
      }
    },
    {
      breakpoint: 480,
      settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      autoplay: true,
      dots: true,
      autoplaySpeed: 4000,
      }
    },
  ]
});
/* Home slider */
$('.abz-new-slider-HP').slick({
  infinite: true,
  slidesToShow:1,
  slidesToScroll: 1,
  arrows: true,
});

// POPPP


$(document).ready(function() {
 $("#paas3d-model-32f98cff-eda9-47d9-89ed-c456c05250fb").fancybox({
   openEffect	: 'elastic',
   closeEffect	: 'elastic',
   helpers : {
   title : {
   type : 'inside'
        }
     }
});
});



var txt = document.getElementById('txt').textContent,
    txtOnly = document.getElementById('txt'),
    btn = document.getElementById('read'),
    subTxt = txt.substring(0,400);

txtOnly.style.display ="none";

function txtD(){

    if(txt.length > 400) {
      txtOnly.innerHTML = subTxt;
      txtOnly.style.display="block";
      console.log(txt.length);
    }  
    else {
      txtOnly.innerHTML = txt;
    }
};
txtD();
btn.onclick = function () {
    'use strict';
    if(btn.classList.contains('more')) {
      btn.classList.remove('more');
      btn.classList.add('less');
      btn.textContent = "Read less";
      txtOnly.innerHTML = txt;
    }
    else {
      btn.classList.remove('less');
      btn.classList.add('more');
      btn.textContent = "Read more";
      txtOnly.innerHTML = subTxt;
    }
};